export var CREHANA_ACADEMIES_TRANSLATION_KEY = 'crehana-academies';
export var HOME_USER_AMPLITUDE_PAGE_NAME = 'Home User';